module.exports = __webpack_public_path__ + "15dc621ed55b62068873c7c2cd8d5541.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/step2.png
// module id = 672
// module chunks = 0